import React, { useState } from 'react';
import { Eye, EyeOff, Lock, Mail } from 'lucide-react';
interface LoginProps {
  onLogin: () => void;
}
const Login: React.FC<LoginProps> = ({
  onLogin
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real implementation, you would validate credentials
    onLogin();
  };
  return <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8" data-id="element-1635">
      <div className="max-w-md w-full space-y-8" data-id="element-1636">
        <div data-id="element-1637">
          <div className="mx-auto h-12 w-12 rounded-md bg-blue-600 flex items-center justify-center" data-id="element-1638">
            <span className="text-white font-bold text-xl" data-id="element-1639">F</span>
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-white" data-id="element-1640">
            Fintrove Admin Dashboard
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600 dark:text-gray-400" data-id="element-1641">
            Sign in to access the admin panel
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-1642">
          <div className="rounded-md shadow-sm -space-y-px" data-id="element-1643">
            <div data-id="element-1644">
              <label htmlFor="email-address" className="sr-only" data-id="element-1645">
                Email address
              </label>
              <div className="relative" data-id="element-1646">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1647">
                  <Mail size={18} className="text-gray-400" data-id="element-1648" />
                </div>
                <input id="email-address" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="appearance-none rounded-t-md relative block w-full px-10 py-3 border border-gray-300 dark:border-gray-600 placeholder-gray-500 text-gray-900 dark:text-gray-100 dark:bg-gray-700 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm" placeholder="Email address" data-id="element-1649" />
              </div>
            </div>
            <div data-id="element-1650">
              <label htmlFor="password" className="sr-only" data-id="element-1651">
                Password
              </label>
              <div className="relative" data-id="element-1652">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1653">
                  <Lock size={18} className="text-gray-400" data-id="element-1654" />
                </div>
                <input id="password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="appearance-none rounded-b-md relative block w-full px-10 py-3 border border-gray-300 dark:border-gray-600 placeholder-gray-500 text-gray-900 dark:text-gray-100 dark:bg-gray-700 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm" placeholder="Password" data-id="element-1655" />
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-1656">
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-1657">
                    {showPassword ? <EyeOff size={18} data-id="element-1658" /> : <Eye size={18} data-id="element-1659" />}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between" data-id="element-1660">
            <div className="flex items-center" data-id="element-1661">
              <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-1662" />
              <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900 dark:text-gray-300" data-id="element-1663">
                Remember me
              </label>
            </div>
            <div className="text-sm" data-id="element-1664">
              <a href="#" className="font-medium text-blue-600 hover:text-blue-500 dark:text-blue-400" data-id="element-1665">
                Forgot your password?
              </a>
            </div>
          </div>
          <div data-id="element-1666">
            <button type="submit" className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-1667">
              Sign in
            </button>
          </div>
        </form>
      </div>
    </div>;
};
export default Login;